/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$chip-focus-color: transparent !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  cursor: pointer;
}

:host [type="button"] {
  @include button-reset-appearance;

  align-items: center;
  background-color: v("backgroundColor");
  color: v("textColor");
  border: 0;
  border-radius: 99px;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  gap: 8px;
  line-height: 18px;
  margin-bottom: 8px;
  margin-right: 8px;
  padding: 2px 2px 2px 10px;
  transition: background-color 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0s, color 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0s;

  .#{$prefix}icon,
  eon-ui-icon {
    background-color: #e6e3e1;
    background-color: v("iconBackgroundColor");
    border-radius: 99px;
    color: v("iconTextColor");
    display: flex;
    height: 18px;
    justify-content: center;
    transition: background-color 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0s, color 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0s;
    width: 18px;
  }

  &:focus-visible,
  &:hover {
    background-color: v("backgroundHoverColor");
    color: v("textHoverColor");

    eon-ui-icon {
      background-color: v("iconBackgroundHoverColor");
      color: v("iconTextHoverColor");
    }
  }

  &:focus {
    outline: 2px solid $chip-focus-color;
  }

  &.#{$prefix}size-small {
    padding: 0px 1px 0px 8px;
    height: 20px;

    eon-ui-icon {
      padding: 0px;
    }
  }
}
